import { configurationApi } from '../configurationApi';
import { ProcedureType } from '../types/procedureType';

interface UploadResponse {
  successful: number;
  failed: number;
  errors: string[];
  isSuccess: boolean;
  errorMessage: string;
}

const procedureEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    getProcedures: builder.query<ProcedureType[], { centerId: string; searchTerm?: string }>({
      query: ({ centerId, searchTerm }) => {
        const params = new URLSearchParams({ centerId });
        if (searchTerm && searchTerm.trim() !== '') params.set('searchTerm', searchTerm.trim());
        return `/procedures?${params.toString()}`;
      },
      providesTags: ['Procedures'],
    }),

    upsertProcedure: builder.mutation<ProcedureType, ProcedureType>({
      query: (procedure) => ({
        url: '/procedure',
        method: 'POST',
        body: procedure,
      }),
      invalidatesTags: ['Procedures'],
    }),

    uploadProcedures: builder.mutation<
      UploadResponse,
      { company: string; centerId: string; file: File }
    >({
      query: ({ company, centerId, file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `Company/${company}/Center/${centerId}/Procedures/Upload`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Procedures'],
    }),

    downloadProcedures: builder.mutation<Blob, { company: string; centerId: string }>({
      query: ({ company, centerId }) => ({
        url: `Company/${company}/Center/${centerId}/Procedures/Download`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),

    getProcedureTypes: builder.query<string[], void>({
      query: () => '/procedure-types',
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetProceduresQuery,
  useUpsertProcedureMutation,
  useUploadProceduresMutation,
  useDownloadProceduresMutation,
  useGetProcedureTypesQuery,
} = procedureEndpoints;
